import { Box } from "@mui/system";
import { React, createContext, useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PersonnelDetailTemplate from "./components/templates/PersonnelDetailTemplate";
import BaseApi from "../../functions/axios";

export const personnelDetailContext = createContext();

export default function PersonnelDetail() {
  const location = useLocation();
  const navigate = useNavigate();

  const [isDrawing, setDrawing] = useState(false);
  const transitionSorce = location.state.transitionSorce;
  const projectId = location.state.projectId;
  const [personnelList, setPersonnelList] = useState([{}]);
  const [matchingIndex, setMatchingIndex] = useState(0);
  const [offerList, setOfferList] = useState([
    { registed_at: "noOffer", bp_name: 0, memo: 0 },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [offset, setOffset] = useState(
    location.state.postData ? location.state.postData.params.offset : -1
  );
  const [nextOffset, setNextOffset] = useState(-1);
  const [prevOffset, setPrevOffset] = useState(-1);
  const [personnelId, setPersonnelId] = useState(location.state.personnelId);
  const [offerStatus, setOfferStatus] = useState({ status: 0, index: -1 });
  const [projectList, setProjectList] = useState([]);
  const postData = location.state.postData;

  const didMountRef = useRef(false);
  const value = {
    personnelId,
    projectId,
    personnelList,
    setPersonnelList,
    matchingIndex,
    setMatchingIndex,
    offerList,
    setOfferList,
    isModalOpen,
    setIsModalOpen,
    offset,
    setOffset,
    nextOffset,
    setNextOffset,
    prevOffset,
    setPersonnelId,
    postData,
    offerStatus,
    setOfferStatus,
    projectList,
    setProjectList,
  };
  const getListFromNewMatching = async () => {
    let tempMatchingIndex = -1;
    const newList = [];
    const res = await BaseApi.get("new_matching", {
      params: {
        cnt: 3,
      },
    });
    const resMatchingList = res.data.data.matching_list;
    tempMatchingIndex = resMatchingList.findIndex(
      (matchingInfo) => matchingInfo.personnel_id === personnelId
    );
    resMatchingList.forEach((item) => {
      const personnels = item.personnels;
      newList.push({
        id: personnels.id,
        initial: personnels.initial,
        cost: personnels.cost_high,
        mail_subject: personnels.mail_subject,
        match_ratio: item.match_ratio,
        score: personnels.score,
        personnel_business_partner_name:
          personnels.personnel_business_partner_name,
        age: personnels.age,
        actual_work: personnels.actual_work,
        gender: personnels.gender,
        belonging: personnels.belonging_flag_label,
        match_words: item.match_words,
        status: false,
        personnel_business_label:
          personnels.belonging_flag_label +
          " / " +
          personnels.employment_status_label,
        comment: personnels.note,
        mail_attachment_filename: personnels.mail_attachment_filename,
      });
    });
    return { tempMatchingIndex, newList };
  };
  const getListFromDirect = async () => {
    let tempMatchingIndex = -1;
    const newList = [];
    const res = await BaseApi.get("personnel_one", {
      params: {
        personnel_id: personnelId,
      },
    });
    if (res.data.result === 9) {
      alert(res.data.message);
      window.location.href = "/";
    }
    const resMatchingList = [res.data.data.personnel];
    tempMatchingIndex = resMatchingList.findIndex(
      (matchingInfo) => matchingInfo.id === personnelId
    );
    resMatchingList.forEach((personnels) => {
      newList.push({
        id: personnels.id,
        initial: personnels.initial,
        cost: personnels.cost_high,
        actual_work: personnels.actual_work,
        mail_subject: personnels.mail_subject,
        match_ratio: 0,
        score: personnels.score,
        personnel_business_partner_name: "",
        age: personnels.age,
        gender: personnels.gender,
        belonging: personnels.belonging_flag_label,
        match_words: "",
        status: false,
        personnel_business_label: "",
        comment: personnels.note,
        mail_attachment_filename: personnels.mail_attachment_filename,
      });
    });
    return { tempMatchingIndex, newList };
  };
  const getListFromRecruitment = async () => {
    let tempMatchingIndex = -1;
    const newList = [];
    const res = await BaseApi.get("recruitment");
    const resProjectList = res.data.data.project_list;
    const tempProjectIndex = resProjectList.findIndex(
      (matchingInfo) => matchingInfo.project_id === projectId
    );
    const resPersonnelList =
      resProjectList[tempProjectIndex].project.personnels;
    tempMatchingIndex = resPersonnelList.findIndex(
      (matchingInfo) => matchingInfo.id === personnelId
    );
    resPersonnelList.forEach((item) => {
      newList.push({
        id: item.id,
        initial: item.initial,
        cost: item.cost_high,
        mail_subject: item.mail_subject,
        match_ratio: item.match_ratio,
        score: item.score,
        personnel_business_partner_name: item.personnel_business_partner_name,
        age: item.age,
        actual_work: item.actual_work,
        gender: item.gender,
        belonging: item.belonging_flag_label,
        match_words: item.match_words,
        status: true,
        personnel_business_label:
          item.belonging_flag_label + " / " + item.employment_status_label,
        comment: item.note,
        mail_attachment_filename: item.mail_attachment_filename,
      });
    });
    return { tempMatchingIndex, newList };
  };
  const getListFromPersonnelList = async (params, url) => {
    let tempMatchingIndex = -1;
    const newList = [];
    const res = await BaseApi.get(url, {
      params,
    });
    const resPersonnelList = res.data.data.personnel_list;
    const next = res.data.data.next;
    setPrevOffset(Math.max(offset - 19, 0));
    setNextOffset(Math.max(next - 2, 0));
    tempMatchingIndex = resPersonnelList.findIndex(
      (matchingInfo) => matchingInfo.id === personnelId
    );
    resPersonnelList.forEach((item) => {
      newList.push({
        id: item.id,
        initial: item.initial,
        cost: item.cost_high,
        mail_subject: item.mail_subject,
        match_ratio: item.match_ratio,
        score: item.score,
        personnel_business_partner_name: item.personnel_business_partner_name,
        age: item.age,
        actual_work: item.actual_work,
        gender: item.gender,
        belonging: item.belonging_flag_label,
        match_words: item.match_words,
        status: item.status,
        personnel_business_label:
          item.belonging_flag_label + " / " + item.employment_status_label,
        comment: item.note,
        mail_attachment_filename: item.mail_attachment_filename,
      });
    });

    return { tempMatchingIndex, newList };
  };
  useEffect(() => {
    const getPersonnelList = async () => {
      let tempMatchingIndex = -1;
      let newList = [];

      if (transitionSorce === "dashboard") {
        const resNewMatching = await getListFromNewMatching();
        tempMatchingIndex = resNewMatching.tempMatchingIndex;
        newList = resNewMatching.newList;
      } else if (transitionSorce === "direct") {
        const resRecruitment = await getListFromDirect();
        tempMatchingIndex = resRecruitment.tempMatchingIndex;
        newList = resRecruitment.newList;
      } else if (transitionSorce === "RecruitmentDetail") {
        const resRecruitment = await getListFromRecruitment();
        tempMatchingIndex = resRecruitment.tempMatchingIndex;
        newList = resRecruitment.newList;
      } else if (
        transitionSorce === "personnelListFromProject" ||
        transitionSorce === "personnelListFromCondition"
      ) {
        const url =
          transitionSorce === "personnelListFromProject"
            ? "matching_personnel_list"
            : "personnel_list";
        const resPersonnelList = await getListFromPersonnelList(
          {
            ...postData.params,
            offset,
          },
          url
        );
        tempMatchingIndex = resPersonnelList.tempMatchingIndex;
        newList = resPersonnelList.newList;
      }

      if (tempMatchingIndex === -1) {
        alert("要員が存在しません");
        if (location.state.transitionSorce === "dashboard") {
          navigate("/dashboard");
        } else {
          navigate(-1);
        }
      } else {
        setDrawing(true);
        setPersonnelList({ ...personnelList, ...newList });
        setMatchingIndex(tempMatchingIndex);
      }
      BaseApi.get("project_title")
        .then((response) => {
          setProjectList(response.data.data.project_list);
        })
        .catch((error) => console.log(error));
    };
    getPersonnelList();
  }, []);

  useEffect(() => {
    const getOfferList = async () => {
      const res = await BaseApi.get("offer_history", {
        params: {
          personnel_id: personnelList[matchingIndex].id,
        },
      });
      const resOfferList = res.data.data.offer_list;
      if (resOfferList.length > 0) {
        setOfferList([...resOfferList]);
      } else {
        setOfferList([{ registed_at: "noOffer", bp_name: 0, memo: 0 }]);
      }
      const offerIndex = resOfferList.findIndex(
        (offer) =>
          projectList.findIndex((project) => project.id === offer.project_id) >=
          0
      );
      if (offerIndex >= 0) {
        if (resOfferList[offerIndex].registed_at) {
          setOfferStatus({ status: 2, index: offerIndex });
        } else {
          setOfferStatus({ status: 1, index: offerIndex });
        }
      } else {
        setOfferStatus({ status: 0, index: offerIndex });
      }
    };
    if (personnelList[matchingIndex]) {
      if (personnelList[matchingIndex].id) {
        getOfferList();
      }
    }
  }, [matchingIndex, projectList]);

  useEffect(() => {
    if (!didMountRef) {
      didMountRef.current = true;
      return;
    }
    const getPersonnelList = async () => {
      let tempMatchingIndex = -1;
      let newList = [];

      if (
        transitionSorce === "personnelListFromProject" ||
        transitionSorce === "personnelListFromCondition"
      ) {
        const url =
          transitionSorce === "personnelListFromProject"
            ? "matching_personnel_list"
            : "personnel_list";
        const resPersonnelList = await getListFromPersonnelList(
          {
            ...postData.params,
            offset,
          },
          url
        );
        tempMatchingIndex = resPersonnelList.tempMatchingIndex;
        newList = resPersonnelList.newList;
      }
      setMatchingIndex(tempMatchingIndex);
      setPersonnelList(newList);
    };
    getPersonnelList();
  }, [offset]);
  return (
    <Box>
      {isDrawing ? (
        <personnelDetailContext.Provider value={value}>
          <PersonnelDetailTemplate />
        </personnelDetailContext.Provider>
      ) : (
        <Box height={500}></Box>
      )}
    </Box>
  );
}
